// ============================================
// INFRASTRUCTURE - Usuarios Repository
// ============================================

import { axiosClient } from './axios-client';
import type { UsuarioSucursal, CrearUsuarioDto, ActualizarUsuarioDto, UsuarioDetalle } from '../../domain/dtos';

export const usuariosRepository = {
  /**
   * Obtener todos los usuarios de todas las sucursales
   * GET /usuarios/all-sucursales
   */
  async obtenerTodosUsuarios(): Promise<UsuarioSucursal[]> {
    const { data } = await axiosClient.get<UsuarioSucursal[]>('/usuarios/all-sucursales');
    return data;
  },

  /**
   * Obtener un usuario por ID con detalles completos
   * GET /usuarios/{usuarioId}
   */
  async obtenerUsuarioPorId(usuarioId: number): Promise<UsuarioDetalle> {
    const { data } = await axiosClient.get<UsuarioDetalle>(`/usuarios/${usuarioId}`);
    return data;
  },

  /**
   * Crear un nuevo usuario
   * POST /usuarios
   */
  async crearUsuario(datos: CrearUsuarioDto): Promise<UsuarioSucursal> {
    const { data } = await axiosClient.post<UsuarioSucursal>('/usuarios', datos);
    return data;
  },

  /**
   * Actualizar un usuario
   * PUT /usuarios
   */
  async actualizarUsuario(datos: ActualizarUsuarioDto): Promise<UsuarioSucursal> {
    const { data } = await axiosClient.put<UsuarioSucursal>('/usuarios', datos);
    return data;
  },

  /**
   * Eliminar un usuario
   * DELETE /usuarios/{usuarioId}
   */
  async eliminarUsuario(usuarioId: number): Promise<void> {
    await axiosClient.delete(`/usuarios/${usuarioId}`);
  },
};
